import { render, staticRenderFns } from "./CityComponent.vue?vue&type=template&id=f548e328&scoped=true&"
import script from "./CityComponent.vue?vue&type=script&lang=js&"
export * from "./CityComponent.vue?vue&type=script&lang=js&"
import style0 from "./CityComponent.vue?vue&type=style&index=0&id=f548e328&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548e328",
  null
  
)

export default component.exports